import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useParams } from 'react-router-dom'
import ArticleAccordionRow from './components/ArticleAccordionRow'
import HomeContent from '../../../src/components/SectionContent'
import TutorialCard from './components/TutorialCard'
import { USE_CASES_MAP } from './config/useCases.config'
import type { UseCaseId } from './types'
import SectionHeading from './components/SectionHeading'
import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { FEATURE_FLAGS } from '@app/app-constants'

const UseCasesLearningPathway = () => {
  const { useCaseId } = useParams<{ useCaseId: UseCaseId }>()
  const useCase = useCaseId ? USE_CASES_MAP[useCaseId] : null

  if (!useCase) return <div>Use case not found: {useCaseId}</div>

  const { learningPathwayIntro, tutorials, articleGroups } = useCase

  return (
    <div className="flex flex-col gap-0 bg-white">
      <HomeContent className="py-8">
        <p className="text-sm leading-relaxed text-foreground">{learningPathwayIntro}</p>
      </HomeContent>

      {/* Tutorials and demos */}
      <FeatureFlagGate flag={FEATURE_FLAGS.HOME_USE_CASE_TUTORIALS}>
        <div className="w-full bg-neutral-200 py-8">
          <HomeContent>
            <SectionHeading>Tutorials and demos</SectionHeading>
            <Carousel opts={{ align: 'start', loop: false }} className="w-full max-w-5xl mx-auto">
              <CarouselContent className="-ml-4">
                {tutorials.map((tutorial) => (
                  <CarouselItem key={tutorial.href} className="pl-4 md:basis-1/2 lg:basis-1/3">
                    <TutorialCard tutorial={tutorial} />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="-left-4 lg:-left-10 rounded-md" size={'icon'} />
              <CarouselNext className="-right-4 lg:-right-10 rounded-md" size={'icon'} />
            </Carousel>
          </HomeContent>
        </div>
      </FeatureFlagGate>

      {/* Accordion */}
      <HomeContent className="py-8">
        <SectionHeading>Articles</SectionHeading>
        <Accordion type="multiple" defaultValue={[`group-0`]} className="w-full">
          {articleGroups.map((group, i) => (
            <AccordionItem key={i} value={`group-${i}`}>
              <AccordionTrigger className="text-sm font-medium text-foreground bg-neutral-100 px-2 data-[state=open]:rounded-t-lg hover:no-underline">
                {group.title}
              </AccordionTrigger>
              <AccordionContent>
                <div className="flex flex-col divide-y divide-border">
                  {group.articles.map((article, j) => (
                    <ArticleAccordionRow key={j} article={article} />
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </HomeContent>
    </div>
  )
}

export default UseCasesLearningPathway
